import { render, staticRenderFns } from "./Return.vue?vue&type=template&id=1f90ec54&scoped=true"
import script from "./Return.vue?vue&type=script&lang=js"
export * from "./Return.vue?vue&type=script&lang=js"
import style0 from "./Return.vue?vue&type=style&index=0&id=1f90ec54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f90ec54",
  null
  
)

export default component.exports